module.exports = __webpack_public_path__ + "static/media/explorer_logo.6c79bb24.png";